import { unsafeMapId } from "@cartographerio/atlas-map";
import { ursMap } from "./helpers";

export const Urs = ursMap(unsafeMapId("urs"), "Urban River Survey");
